module.exports = require("zlib");